import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { BankStore, ContactStore } from '../../core/stores/base.store';
import { formatDateAsYYYYMMDD } from 'app/core/utils/date.utils';
import { NumberFormatDirective } from '../../core/utils/comma.utils';
import { LoanUtils } from '../../core/utils/loan.utils';
import { NotificationUtils } from '../../core/utils';

@Component({
  selector: 'app-bank-withdraw-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    NumberFormatDirective
  ],
  templateUrl: './bank-withdraw-dialog.component.html',
  styleUrls: ['./bank-withdraw-dialog.component.css']
})
export class BankWithdrawDialogComponent implements OnInit {
  withdrawForm!: FormGroup;
  
  private bankStore = inject(BankStore);
  private contactStore = inject(ContactStore);
  private fb = inject(FormBuilder);
  
  selectedBank = this.bankStore.selected;

  // Get the self contact
  getSelfContact() {
    return this.contactStore.entities().find(contact => contact.category === 'Self');
  }
  
  constructor(
    public dialogRef: MatDialogRef<BankWithdrawDialogComponent>
  ) {}
  
  ngOnInit(): void {
    this.withdrawForm = this.fb.group({
      amount: ['', [Validators.required, Validators.min(0.01)]],
      date: [new Date(), Validators.required],
      category: ['', Validators.required],
      contact_id: [null],
    });
  }
  
  onSubmit(): void {
    if (this.withdrawForm.invalid) {
      return;
    }
    
    const formValue = this.withdrawForm.value;
    const bank = this.selectedBank();
    
    if (!bank) {
      NotificationUtils.getInstance().showError('No bank selected');
      return;
    }
    
    // Create the withdrawal transaction
    const withdrawalTransaction = {
      bank_id: bank.id,
      transaction_date: formatDateAsYYYYMMDD(formValue.date),
      amount: -Math.abs(LoanUtils.parseFormattedNumber(formValue.amount)), // Negative for withdrawal
      category: formValue.category,
      contact_id: this.getSelfContact()?.id,
      loan_id: null,
      insurance_id: null,
      insurance_loan_id: null,
      principal: null,
      interest: null,
      late_fee: null
    };
    
    try {
      // Save the withdrawal transaction
      this.bankStore.createChild({ 
        child: withdrawalTransaction, 
        endpoint: 'bank_transaction', 
        collectionName: 'bank_transactions_collection' 
      });
      
      NotificationUtils.getInstance().showSuccess('Withdrawal recorded successfully');
      this.dialogRef.close(true);
    } catch (error) {
      NotificationUtils.getInstance().showError('Error recording withdrawal');
      console.error('Error creating withdrawal transaction:', error);
    }
  }
  
  onCancel(): void {
    this.dialogRef.close(false);
  }
}